import "./AppInput.scss"
import React, { FC, ReactNode, useState } from "react"
import {
  TextField,
  FormControl,
  FormHelperText,
  InputAdornment,
  FormLabel,
  Typography,
  Box,
} from "@mui/material"
import CountrySelectPrefix from "./CountrySelectPrefix"

type PhoneInputProps = {
  label: string
  name: string
  value: string
  error?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: () => void
  type?: string
  className?: string
  disabled?: boolean
  startAdornment?: ReactNode
  endAdornment?: ReactNode
}

const PhoneInput: FC<PhoneInputProps> = ({
  label,
  name,
  value,
  error,
  onChange,
  onBlur,
  type = "text",
  className,
  disabled,
  startAdornment,
  endAdornment,
}) => {
  const [countryCode, setCountryCode] = useState("+972")
  const [phone, setPhone] = useState("")

  const handleCountryChange = (code: string) => {
    setCountryCode(code)
  }

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const phone = e.target.value
    setPhone(phone) // Keep the input as entered by the user
  
    // Remove leading zero when sending the value to the form
    const phoneToSend = phone.startsWith("0") ? phone.substring(1) : phone
  
    if (onChange) {
      onChange({
        target: {
          name,
          value: countryCode + phoneToSend, // Send modified phone number
        },
      } as React.ChangeEvent<HTMLInputElement>)
    }
  }
  
  return (
    <FormControl
      error={!!error}
      className={`app-input ${className || ""}`.trim()}
    >
      <FormLabel className="label">
        <Typography className="body1">{label}</Typography>
      </FormLabel>
      <Box sx={{ display: "flex", alignItems: "center", direction: "ltr" }}>
        <CountrySelectPrefix onChange={handleCountryChange} />
        <TextField
          sx={{
            "& .MuiInputBase-formControl": {
              flex: 1,
              width: "169px !important",
            },
          }}
          type={type}
          name={name}
          value={phone}
          onChange={handlePhoneChange}
          onBlur={onBlur}
          className="base-input"
          error={!!error}
          disabled={disabled}
          InputProps={{
            startAdornment: startAdornment && (
              <InputAdornment position="start">{startAdornment}</InputAdornment>
            ),
            endAdornment: endAdornment && (
              <InputAdornment position="end">{endAdornment}</InputAdornment>
            ),
          }}
        />
      </Box>
      <FormHelperText>{error}</FormHelperText>
    </FormControl>
  )
}

export default PhoneInput
